import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid lg:grid-cols-2 gap-12" }

import SignInForm from "@/forms/SignInForm.vue";
import SignUpForm from "@/forms/SignupForm.vue";
import Title from "@/components/Title.vue";
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'SignInView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Title, null, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("TSG R&D Collaboration Hub")
      ])),
      _: 1,
      __: [0]
    }),
    _createVNode(Divider),
    _createVNode(Content, null, {
      default: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("p", null, " This website is not public. You need an account to access it. ", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", null, " If you do not have an account yet, you can create one yourself. Only email addresses that belong to a domain of a TSG business unit are allowed. You'll be sent an email with a verification link. ", -1)),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(SignInForm),
          _createVNode(SignUpForm)
        ])
      ]),
      _: 1,
      __: [1,2]
    })
  ], 64))
}
}

})